<template>
	<modal-box @close="close" :header="$t(`buttons.actions.${params.action}_appointment`)" :subHeader="$t('headers.general.appointment')" class="appointment-form">
		<spinner v-if="model.loading"/>
		<error-box v-else-if="model.error" :error="model.error"/>
		<form v-else @submit.prevent="validateAndSubmit">
			<input-text v-model="model.data.name" name="appointment_name" :placeholder="$t('labels.general.name')"  rules="required"/>
			<input-date v-model="model.data.date" name="appointment_date" :placeholder="$t('labels.general.date')"  rules="required"/>
			<input-time v-model="model.data.hour" name="appointment_hour" :placeholder="$t('labels.general.hour')"  rules="required"/>
			<input-text v-model="model.data.location" name="appointment_location" :placeholder="$t('labels.general.location')" />
			<input-textarea v-model="model.data.description" name="appointment_description" :placeholder="$t('labels.general.description')"/>
			<error-box v-if="form.error" :error="form.error"/>
			<div class="form-group-actions">
				<button-submit-icon-text :loading="form.loading" icon="save">{{ $t('buttons.general.save') }}</button-submit-icon-text>
			</div>
		</form>
	</modal-box>
</template>

<script>
import ApiObject from '@/classes/api/ApiObject'
import Appointment from '@/classes/Appointment'
export default {
	props: [
		'user_uid',
		'watch_id',
		'params'
	],
	data () {
		return {
			model: new ApiObject(),
			form: {
				loading: false,
				error: ''
			}
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll()
				.then(result => {
					if (result) this.submit()
				})
		},
		submit () {
			switch (this.params.action) {
				case 'add':
					this.addAppointment()
					break
				case 'edit':
					this.editAppointment()
					break
				default:
					this.$log.warn('watch appointments form', 'action not set')()
			}
		},
		close (reload = false) {
			this.$emit('close', { reload })
		},
		getAppointment () {
			this.model.loading = true
			this.$api.appointments.get(this, this.user_uid, this.watch_id, this.params.id)
				.then(response => {
					this.$log.info('watch appointments form', 'appointments.get OK', response)()
					this.model.data = this.newAppointment(response.body)
				}).catch(error => {
					this.$log.error('watch appointments form', 'appointments.add ERROR', error)()
					this.model.error = error
				}).finally(() => {
					this.model.loading = false
				})
		},
		addAppointment () {
			this.form.loading = true
			const model = this.serializeModel()
			this.$api.appointments.add(this, this.user_uid, this.watch_id, model)
				.then(response => {
					this.$log.info('watch appointments form', 'appointments.add OK', response)()
					this.close(true)
				}).catch(error => {
					this.$log.error('watch appointments form', 'appointments.add ERROR', error)()
					this.form.error = error
				}).finally(() => {
					this.form.loading = false
				})
		},
		editAppointment () {
			this.form.loading = true
			const model = this.serializeModel()
			this.$api.appointments.edit(this, this.user_uid, this.watch_id, model)
				.then(response => {
					this.$log.info('watch appointments form', 'appointments.edit OK', response)()
					this.close(true)
				}).catch(error => {
					this.$log.error('watch appointments form', 'appointments.add ERROR', error)()
					this.form.error = error
				}).finally(() => {
					this.form.loading = false
				})
		},
		newAppointment (data) {
			const appointment = new Appointment(data)
			if (data) {
				appointment.date = this.$moment(appointment.datetime).format('YYYY-MM-DD'),
				appointment.hour = this.$moment(appointment.datetime).format('HH:mm')
			} else {
				appointment.date = this.$moment().format('YYYY-MM-DD'),
				appointment.hour = this.$moment().format('HH:mm')
			}
			delete appointment.datetime
			return appointment
		},
		serializeModel () {
			return {
				id: this.model.data.id,
				name: this.model.data.name,
				date: this.$moment(`${this.model.data.date} ${this.model.data.hour}`).format(),
				location: this.model.data.location,
				description: this.model.data.description
			}
		}
	},
	created () {
		switch (this.params.action) {
			case 'add':
				this.model.data = this.newAppointment()
				break
			case 'edit':
				this.getAppointment()
				break
			default:
				this.$log.warn('watch appointments form', 'action not set')()
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/appointments/AppointmentForm.vue